export default __webpack_public_path__ + "static/media/angle-left-black-icon.2c5f6057.svg";